import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import SearchView from "../../widgets/SearchView";
import QualificationSetupSearchForm from './QualificationSetupSearchForm';
import { ViewContainer } from "./../../View.jsx";
import CardLayout from '../../widgets/Card';
import ViewUtils from '../../ViewUtils';

const utils = new ViewUtils();

const headCells = [
    { id: "SAQAQualificationID", numeric: false, disablePadding: true, label: "Qualification ID" },
    { id: "SAQAQualificationTitle", numeric: false, disablePadding: true, label: "Qualification Title" }
]

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'info', label: '', tooltip: 'Select a Qualification from the table and click save to add', icon: 'InfoIcon' }
            ]
        }
    ]
}

const searchParameters = [
    { Name: "SAQAQualificationID", Value: "" },
    { Name: "SAQAQualificationTitle", Value: "" }
]

class LearnerQualificationSearchSearch extends Component {
    state = {
        model: {
            SAQAQualificationID: "",
            SAQAQualificationTitle: ""
        },
        keyUpSwitch: false
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={this.props.showTitle === true || utils.isNull(this.props.showTitle) ? 'Qualifications' : null}>
                <SearchView
                    config={toolbarConfig}
                    mode={this.props.mode}
                    headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/indicium/learner/qualificationsearch"}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="SAQAQualificationID"
                    SecondDescriptionProp="SAQAQualificationTitle"
                    model={this.state.model}
                    searchParameters={searchParameters}
                    keyUpSwitch={this.state.keyUpSwitch}
                >
                    <QualificationSetupSearchForm onKeyUp={(e) => { this.onkeyup(e) }} model={this.state.model} valueChangeHandler={(values) => {
                        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                            this.setState({ model: values });
                        }
                    }} />
                </SearchView>
            </ViewContainer>
            )
    }
}

export default withRouter(
    connect()(LearnerQualificationSearchSearch)
);